let dragSrcEl = null;
function handleDragStart(e) {
    dragSrcEl = e.currentTarget;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setDragImage(e.currentTarget, 0, 0);
    e.currentTarget.setAttribute('cds-draggable', 'active');
}
function handleDragOver(e) {
    if (e.preventDefault) {
        e.preventDefault();
    }
    e.dataTransfer.dropEffect = 'move';
    if (dragSrcEl !== e.currentTarget) {
        e.currentTarget.setAttribute('cds-draggable', 'target');
    }
    return false;
}
function handleDrop(e) {
    e.currentTarget.parentElement.querySelector('[cds-draggable*="target"]').setAttribute('cds-draggable', '');
    e.currentTarget.setAttribute('cds-draggable', '');
    const items = Array.from(e.currentTarget.parentElement.querySelectorAll('[draggable]'));
    const fromIndex = items.findIndex(i => i === dragSrcEl);
    let targetIndex = items.findIndex(i => i === e.currentTarget);
    targetIndex = targetIndex > fromIndex ? targetIndex - 1 : targetIndex;
    const from = dragSrcEl;
    const target = items.find(i => i === e.currentTarget);
    e.currentTarget.dispatchEvent(new CustomEvent('draggableChange', { detail: { from, target, type: 'drop' }, bubbles: true }));
    return false;
}
function handleDragLeave(e) {
    e.currentTarget.setAttribute('cds-draggable', e.currentTarget.getAttribute('cds-draggable').replace('target', ''));
}
function addHandlers(elem) {
    elem.setAttribute('cds-draggable', '');
    elem.addEventListener('dragstart', handleDragStart, false);
    elem.addEventListener('dragover', handleDragOver, false);
    elem.addEventListener('drop', handleDrop, false);
    elem.addEventListener('dragleave', handleDragLeave, false);
    elem.addEventListener('dragend', e => e.currentTarget.setAttribute('cds-draggable', e.currentTarget.getAttribute('cds-draggable').replace('active', '')), false);
}
export class CdsDraggableList {
    constructor(listRoot) {
        this.listRoot = listRoot;
        this.addListeners();
        const observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {
                    this.addListeners();
                }
            }
        });
        observer.observe(this.listRoot, { childList: true });
    }
    get items() {
        return Array.from(this.listRoot.querySelectorAll('[draggable=true]'));
    }
    get dropZones() {
        return Array.from(this.listRoot.querySelectorAll('[draggable=false]'));
    }
    addListeners() {
        this.items.filter(i => i.hasAttribute('cds-draggable')).forEach(i => i.setAttribute('cds-draggable', ''));
        this.items.filter(i => !i.hasAttribute('cds-draggable')).forEach(item => addHandlers(item));
        this.dropZones.filter(i => !i.hasAttribute('cds-draggable')).forEach(elem => {
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
        });
    }
}
//# sourceMappingURL=draggable-list.js.map